module.exports = __webpack_public_path__ + "static/media/company11.ad0bb7c4.png";